(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(el) {
    if (el.dataset.khaiaScroll) return;
    el.dataset.khaiaScroll = '1';
    var down = false, startX = 0, startLeft = 0, moved = 0;
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; moved = 0; startX = e.clientX; startLeft = el.scrollLeft;
      try { el.setPointerCapture(e.pointerId); } catch (x) {}
    });
    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { el.classList.add('is-dragging'); moved = Math.abs(dx); }
      el.scrollLeft = startLeft - dx;
    });
    function up() { down = false; setTimeout(function () { el.classList.remove('is-dragging'); }, 0); }
    el.addEventListener('pointerup', up);
    el.addEventListener('pointercancel', up);
    el.addEventListener('pointerleave', up);
    el.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
  }
  function initWheel(el) {
    if (el.dataset.khaiaWheel) return; el.dataset.khaiaWheel = '1';
    el.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      if (el.scrollWidth <= el.clientWidth) return;
      el.scrollLeft += e.deltaY; e.preventDefault();
    }, { passive: false });
  }
  function run() { document.querySelectorAll('.khaia-recs').forEach(function (el) { init(el); initWheel(el); }); }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();
})();
